"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var asg_1 = require("@alinta-digital/asg");
var TotalBalanceAmt = function (props) {
    var balance = parseFloat(props.totalBalance);
    return (react_1.default.createElement(asg_1.Text, { width: "100%", textAlign: "end", size: "28px", "data-testid": "accountBalanceAmount", weight: 700, color: asg_1.colors.primaryText },
        "$",
        Math.abs(balance).toFixed(2)));
};
exports.default = TotalBalanceAmt;
//# sourceMappingURL=TotalBalanceAmt.js.map